<script lang="ts">
    import PanelistAlternativePage from '@Evaluation/Estimations/Pages/PanelistAlternativePage'
    export default PanelistAlternativePage
</script>

<template>
    <div>
        <AlternativeDetailsDialog :viewModel="alternativeDetailsDialog" />
        <AttributeDescriptionDialog :viewModel="attributeDescriptionDialog" />

        <div class="container">
            <h3 v-if="!Initialized" class="text-center"><i class="fa fa-spinner fa-spin"></i> Loading...</h3>

            <div v-if="Initialized">

                <nav class="navbar fixed-bottom navbar-dark bg-dark">
                    <div class="container d-flex justify-content-center">
                        <div class="btn-group" role="group">
                            <a class="btn btn-secondary" v-sanitizedHref="PrevAlternativeUrl">
                                <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                                Prev <span class="text-lowercase d-none d-sm-inline">{{AlternativeLabel}}</span>
                            </a>
                            <button type="button" class="btn btn-warning" @click="ScrollTopCommand">
                                Back to Top
                            </button>
                            <a class="btn btn-secondary" v-sanitizedHref="NextAlternativeUrl">
                                Next <span class="text-lowercase d-none d-sm-inline">{{AlternativeLabel}}</span>
                                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                </nav>

                <nav class="navbar navbar-expand-md navbar-dark bg-dark fixed-top">
                    <div class="container">

                        <a class="btn btn-light mr-auto" v-sanitizedHref="DashboardUrl">
                            <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                            My Survey
                        </a>

                        <div class="progress mx-2 w-50" style="height: 38px; background-color: #D3D3D3;">
                            <div class="progress-bar" role="progressbar" :style="{width: Progress + '%'}">{{ProgressStr}}</div>
                        </div>

                        <button v-show="IsSaved == null" type="button" class="btn btn-warning" @click="Save">
                            <i class="fa fa-spinner fa-spin"></i> Saving...
                        </button>
                        <button v-show="IsSaved === true" type="button" class="btn btn-light" @click="Save">
                            Saved
                        </button>
                        <button v-show="IsSaved === false" type="button" class="btn btn-warning" @click="Save">
                            Save
                        </button>
                    </div>
                </nav>


                <div style="padding-top: 80px; padding-bottom: 120px;">
                    <h3 id="top" class="mt-4">
                        <span class="font-weight-light">Evaluate <span class="text-lowercase">{{AlternativeLabel}}</span>: </span>
                        <span>{{Name}}</span>
                    </h3>
                    <hr />

                    <nav class="navbar navbar-expand-md navbar-light bg-light">
                        <ul class="navbar-nav">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Questions: <span>{{QuestionsFilter}}</span>
                                </a>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" @click="SetQuestionsFilterCommand('All')">All <span class="badge badge-secondary">{{QuestionsCount}}</span></a>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" @click="SetQuestionsFilterCommand('Answered')">Answered <span class="badge badge-secondary">{{AnsweredQuestionsCount}}</span></a>
                                    <a class="dropdown-item" @click="SetQuestionsFilterCommand('Not answered')">Not answered <span class="badge badge-secondary">{{NotAnsweredQuestionsCount}}</span></a>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" @click="SetQuestionsFilterCommand('Has value')">Has value <span class="badge badge-secondary">{{VotedQuestionsCount}}</span></a>
                                    <a class="dropdown-item" @click="SetQuestionsFilterCommand('No value')">No value <span class="badge badge-secondary">{{NotVotedQuestionsCount}}</span></a>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" @click="SetQuestionsFilterCommand('Commented')">Commented <span class="badge badge-secondary">{{CommentedQuestionsCount}}</span></a>
                                    <a class="dropdown-item" @click="SetQuestionsFilterCommand('Not commented')">Not commented <span class="badge badge-secondary">{{NotCommentedQuestionsCount}}</span></a>
                                </div>
                            </li>
                        </ul>
                        <form class="form-inline my-2 my-lg-0 ml-auto">
                            <input class="form-control mr-sm-2" type="search" placeholder="Filter attributes" v-model="SearchPhrase">
                        </form>
                    </nav>

                    <div v-for="q in QuestionsView">
                        <p class="mt-5 mb-3 lead">
                            <strong>{{q.OrderValue}}.</strong>
                            How would you rate <span class="text-lowercase">{{AlternativeLabel}}</span>
                            <a class="text-primary font-italic" @click="ShowAlternativeDetailsCommand">{{Name}}</a>
                            in the context of <a class="text-primary" @click="ShowAttributeDetailsCommand(q)">{{q.AttributeName}}</a>?
                        </p>

                        <div class="row">
                            <div class="col-md-8">
                                <SurveyVoteEditor :Value="q.Value"
                                                  :Comment="q.Comment"
                                                  :HasAnswer="q.HasAnswer"
                                                  :HasScale="q.HasScale"
                                                  :ScaleLevels="q.ScaleLevels"
                                                  @update-value="handleVoteValueUpdate(q, $event)"
                                                  @update-comment="handleVoteCommentUpdate(q, $event)" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>


</template>
